import {
  Alert as DfhAlert,
  RadioButton as DfhRadioButton,
  RadioButtonGroup as DfhRadioButtonGroup,
  TextInput,
} from '@designsforhealth/dfh-react-components'
import styled, { css } from 'styled-components'
import { PrivacyNoticeLink as PrivacyNoticeTermsLink } from '../terms/terms-links/PrivacyNoticeLink'
import { TermsOfSaleLink as TermsOfSaleTermsLink } from '../terms/terms-links/TermsOfSaleLink'
import { TermsOfUseLink as TermsOfUseTermsLink } from '../terms/terms-links/TermsOfUseLink'

export const RegistrationForm = styled.form`
  // constrain to prevent excess width due to child elements (e.g. ReCAPTCHA)
  width: 100%;
  padding-bottom: 50px;
`

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.06em;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  color: ${({ theme }) => theme.colors.grayscale.black};
  text-transform: uppercase;
  margin-bottom: 20px;
`

export const TitleHelper = styled.div`
  font-size: 15px;
  line-height: 30px;
  display: block;
  font-weight: 300;
  text-transform: none;
  letter-spacing: 0;
`

export const CustomTextInput = styled(TextInput)`
  margin-bottom: 0;
`

export const FieldsRow = styled.div<{ $gutter?: boolean; $hide?: boolean }>`
  display: ${({ $hide }) => ($hide ? 'none' : 'flex')};
  flex-direction: column;
  flex-wrap: wrap;
  position: relative;
  ${({ $gutter }) =>
    $gutter &&
    css`
      margin-bottom: 20px;
    `};
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 2%;
  }
`

export const HalfColumn = styled.div`
  position: relative;
  width: 100%;

  button {
    top: 50%;
  }
`

const termsLinkStyles = css`
  && {
    bottom: 2px;
    line-height: 1.6;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const PrivacyNoticeLink = styled(PrivacyNoticeTermsLink)`
  ${termsLinkStyles}
`

export const TermsOfUseLink = styled(TermsOfUseTermsLink)`
  ${termsLinkStyles}
`

export const TermsOfSaleLink = styled(TermsOfSaleTermsLink)`
  ${termsLinkStyles}
`

export const SwitchZipOrCodeButtonContainer = styled.div`
  width: 100%;
  height: auto;
  text-align: right;
  margin: inherit;
`

export const SwitchZipOrCodeButton = styled.button`
  background-color: transparent;
  border-radius: 0;
  border: none;
  padding: 5px 10px;
  font-size: 0.7rem;
  text-align: initial;
  color: ${({ theme }) => theme.colors.brand.orange};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const ContentWrapper = styled.div<{ $hasPractitionerSelected?: boolean }>`
  ${({ $hasPractitionerSelected }) =>
    $hasPractitionerSelected &&
    css`
      margin-bottom: 40px;
    `};
`

export const Bold = styled.span`
  font-weight: bold;
`

export const LegalDisclaimer = styled.p`
  ${({ theme }) => theme.typography.body3};
  color: ${({ theme }) => theme.colors.coolGray.cool900};
`

export const Alert = styled(DfhAlert)`
  margin-top: -10px;
`

export const RadioButtonGroup = styled(DfhRadioButtonGroup)`
  flex-direction: column;
  ${DfhRadioButton} {
    label {
      border: none;
      padding: 0;
    }
    &:first-of-type label {
      border: none;
    }
    &:last-of-type label {
      border: none;
    }
  }
`

export const RadioButtonGroupTitle = styled(Title)`
  margin-bottom: 10px;
`
